import { Step } from "UIKit";
import { useTranslation } from "react-i18next";
import AccessTypeForm from "./AccessTypeForm";

interface useSpaceAccessTypeStepProps {
  onSubmit: () => void;
  spaceName: string;
  onChange: ({ isPublic }: { isPublic: boolean }) => void;
  isPublic: boolean;
}

export const useSpaceAccessTypeStep = ({
  onSubmit,
  spaceName,
  onChange,
  isPublic,
}: useSpaceAccessTypeStepProps): Step<"access"> => {
  const { t } = useTranslation();

  const handleChangeAccessType = (isPublic: boolean) => {
    onChange({ isPublic });
  };

  const handleSubmitAccessType = async () => {
    onSubmit();
  };
  return {
    name: "access",
    title: t("space_access_type_title", { spaceName }),
    component: <AccessTypeForm defaultIsPublic={isPublic} onChange={handleChangeAccessType} />,
    onSubmit: handleSubmitAccessType,
  };
};
